export default {
  LIST(state, data) {
    state.regions = data
  },
  UPDATE(state, value) {
    state.region = {
      ...value,
      country: value.country.id,
    }
  },
  FRESH(state) {
    state.region = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
      country: null,
    }
  },
}
